<template>
  <el-dialog title="批量操作" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form size="small" :model="formData" :rules="formRules" ref="form">

      <!--名称-->
      <el-form-item label="选中数量" :label-width="formLabelWidth">
        <p class="red f20">{{ formData.ids.length || '暂无选中记录' }}</p>
      </el-form-item>

      <!--类型-->
      <el-form-item label="类型" prop="type" :label-width="formLabelWidth">
        <el-select v-model="formData.type">
          <el-option label="顶级" value=""></el-option>
          <el-option :value="item.key_name" :label="item.name" :key="item.key_name" v-for="item in typeData"></el-option>
        </el-select>
      </el-form-item>

      <!--是否显示-->
      <el-form-item label="状态" prop="status" :label-width="formLabelWidth">
        <el-radio-group v-model="formData.status">
          <el-radio label="">不限</el-radio>
          <el-radio :label="1">未激活</el-radio>
          <el-radio :label="2">已激活</el-radio>
        </el-radio-group>
      </el-form-item>

      <!--是否删除-->
      <el-form-item label="删除" prop="is_delete" :label-width="formLabelWidth">
        <el-radio-group v-model="formData.is_delete">
          <el-radio label="">否</el-radio>
          <el-radio :label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>
      
    </el-form>
    <!--操作按钮-->
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="onSubmit()" :disabled="loading || ids.length==0">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import CodeApi from '@/api/study/code.js';
import { alphabet } from '@/utils/base.js';
export default {
  data() {
    return {
      /*是否加载中*/
      loading: false,
      /*form表单数据对象*/
      formData: {
        ids: [],
        type: '',
        status: '',
        is_delete: '',
      },
      /*验证规则*/
      formRules: {},
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否显示*/
      dialogVisible: false,
    };
  },
  props: ['is_open', 'ids', 'typeData'],
  created() {
    this.dialogVisible = this.is_open;
    this.formData.ids = this.ids;
  },
  methods: {
    /*添加*/
    onSubmit() {
      let self = this;
      let params = this.formData;
      if (params.ids.length<=0){
        self.$message({
          message: '暂无选中记录',
          type: 'warning'
        });
        return;
      }
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          CodeApi.batch(params, true)
            .then(res => {
              if (res.code == 1) {
                self.$message({
                  message: res.msg,
                  type: 'success'
                });
                self.dialogFormVisible(true);
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit('closeDialog', {
          type: 'success',
          openDialog: false
        });
      } else {
        this.$emit('closeDialog', {
          type: 'error',
          openDialog: false
        });
      }
    },
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/study/code/code/part/Batch.vue